import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import "./AboutUsHome.css";

const visionMissionData = [
  {
    icon: "./assets/img/slider/vision-icon1.svg",
    title: "Our Vision",
    text: "Our vision is to expand our global footprint and enhance our position as a leader in the import-export sector, recognized for our reliability, innovation, and customer-centric approach.",
  },
  {
    icon: "./assets/img/slider/vision-icon2.svg",
    title: "Our Mission",
    text: "Our Mission is to be the preferred partner in international trade by delivering superior quality products and exceptional service while championing sustainability and ethical business practices.",
  },
  {
    icon: "./assets/img/slider/vision-icon3.svg",
    title: "Our Values",
    text: "We believe that transparency and being dedicated to delivering the best possible experience to every client are integral to building relationships based on trust.",
  },
];

const VisionMissionItem = ({ icon, title, text }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <motion.div
      ref={ref}
      className="row"
      initial={{ opacity: 0, y: 50 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.5 }}
    >
      <div className="col-md-2">
        <figure className="d-flex align-items-center justify-content-center">
          <img src={icon} alt={title} />
        </figure>
      </div>
      <div className="col-md-10">
        <h5>{title}</h5>
        <p className="aboutus-home-values">{text}</p>
      </div>
    </motion.div>
  );
};

function AboutUsHome() {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <motion.section
      ref={ref}
      className="c-vision-mission w-100"
      initial={{ opacity: 0 }}
      animate={inView ? { opacity: 1 } : {}}
      transition={{ duration: 0.8 }}
    >
      <div className="container">
        <motion.div
          className="c-section-header text-center"
          initial={{ opacity: 0, y: -20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="c-section-title">Vision &amp; Mission</h2>
          <p className="aboutus-home-values">
            We are forward-thinking, solutions-oriented, and dedicated to
            delivering the best possible quality of service.
          </p>
        </motion.div>
        <div className="row align-items-center">
          <motion.div
            className="col-md-6"
            initial={{ opacity: 0, x: -50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.5 }}
          >
            <img src="./assets/img/slider/about-figure.svg" alt="About Us" />
          </motion.div>
          <div className="col-md-6">
            <div className="c-vision-mission__list">
              {visionMissionData.map((item, index) => (
                <VisionMissionItem key={index} {...item} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
}

export default AboutUsHome;
